import { render, staticRenderFns } from "./page3.vue?vue&type=template&id=1415ea4e&scoped=true"
import script from "./page3.vue?vue&type=script&lang=js"
export * from "./page3.vue?vue&type=script&lang=js"
import style0 from "./page3.vue?vue&type=style&index=0&id=1415ea4e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1415ea4e",
  null
  
)

export default component.exports